import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import SatisfactionSurveyIndex from './Index.vue';

// Pesquisa de Satisfacao remodelada (CSAT + NPS + CES) - feature propria
// do MensageiroPro, nao depende de installationTypes Enterprise.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/satisfaction-survey'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'satisfaction_survey_list',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'satisfaction_survey_list',
          meta: {
            featureFlag: FEATURE_FLAGS.REPORTS,
            permissions: ['administrator'],
          },
          component: SatisfactionSurveyIndex,
        },
      ],
    },
  ],
};
